<template>
  <section
    v-if="articles && articles.totalRows > 0"
    class="section has-background-warning"
  >
    <div class="container">
      <h2 class="title is-3">
        {{ $texts('related_articles', 'Verwandte Artikel') }}
      </h2>
      <div class="columns">
        <div
          v-for="teaser in articles.rows"
          :key="teaser.nid"
          class="column is-one-quarter"
        >
          <node-article-teaser v-bind="teaser" class="is-dark" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { NodeArticleTeaserFragment } from '#graphql-operations'

const props = defineProps<{
  nid?: number
  tids: Array<string | undefined>
}>()

const { $texts } = useNuxtApp()

const perPage = ref(4)

const offset = useQueryString('offset', '')

const { data: articles } = await useAsyncData(async () => {
  const variables = {
    tids: props.tids?.join('+'),
    nid: '' + props.nid,
    limit: perPage.value,
    offset: '',
  }

  if (props.tids?.length <= 0) {
    return
  }

  if (parseInt(offset.value) > 0) {
    variables.offset = offset.value
  }

  return await useGraphqlQuery('relatedArticles', variables).then((v) => {
    return {
      rows:
        // @ts-ignore
        (v.data?.entityById?.executable?.execute
          ?.rows as NodeArticleTeaserFragment[]) || [],
      // @ts-ignore
      totalRows: v.data?.entityById?.executable?.execute?.totalRows || 0,
    }
  })
})
</script>
